import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceExport\AccountingExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/AccountingExportController.php
* @route '/api/invoice/export/account-diary'
*/
const AccountingExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AccountingExportController.url(options),
    method: 'post',
})

AccountingExportController.definition = {
    methods: ["post"],
    url: '/api/invoice/export/account-diary',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\InvoiceExport\AccountingExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/AccountingExportController.php
* @route '/api/invoice/export/account-diary'
*/
AccountingExportController.url = (options?: RouteQueryOptions) => {
    return AccountingExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceExport\AccountingExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/AccountingExportController.php
* @route '/api/invoice/export/account-diary'
*/
AccountingExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AccountingExportController.url(options),
    method: 'post',
})

export default AccountingExportController